import { Col, Row, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import { CustomButton, showToaster, toasterTypes } from "../../widgets"
import ModalComponent from "../common/Modal/modal"
import { FIELD_TYPES, FieldItem } from "../../widgets/fields"
import { CreateFormElements } from "./FormElements"
import { useEffect, useMemo, useState } from "react"
import useFieldItem from "../../widgets/fields/UseFieldItem"
import { useDispatch } from "react-redux"
import { refreshTokenThunk, setLoading } from "../../store/slices/auth"
import { uploadPhoto } from "../profile/apiController"
import { getDumpFilesStatus, uploadDumpFiles } from "./apiController"
import classnames from 'classnames'
import { fetchUserCredits } from "../literatureSearch/apiController"
import NoUserCreditsModal from "../common/AiModuleComponents/NoUserCreditsModal"
import { agentNamesDataMap } from "../common/utils/aiAgentsData"

const Dump = (props) => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('1');
    const [dumpFilesStatus, setDumpFilesStatus] = useState<any>();
    const [isCreditsAvailable, setIsCreditsAvailable] = useState<boolean>(false);

    const initialValues = useMemo(() => (
        props.previousState ?
            props.previousState :
            { dumpFiles: "" }
    ), [props.previousState]);

    const [values, fields, handleChange, { validateValues, updateValue }] = useFieldItem(CreateFormElements, initialValues, { onValueChange });

    useEffect(() => {
        // console.log(props)
        checkUserCredits()
        // getDumpFileStatusData();
    }, [])

    async function checkUserCredits() {
        try {
            dispatch(setLoading(true));
            const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
            const ocrAgent = aiAgents.find((agent: any) => agent.name === agentNamesDataMap.ocr);

            const response: any = await fetchUserCredits(ocrAgent?.id, props?.projectData.TopicID);
            if (response?.status) {
                getDumpFileStatusData();
                setIsCreditsAvailable(true);
            } else {
                setIsCreditsAvailable(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setLoading(false));
        }
    }

    const getDumpFileStatusData = async () => {
        try {
            dispatch(setLoading(true));
            const response: any = await getDumpFilesStatus(props.projectData.TopicID, props.formData.id);
            // console.log(response);
            if (response.status === "SUCCESS") {
                setDumpFilesStatus(response);
            }
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    }

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    function onValueChange(name, value, values, fieldValues = null) {
        let resetValue = {};

        return [{
            ...values,
            ...resetValue,
            [name]: value,
        }]
    }

    const onSave = async () => {
        try {
            dispatch(setLoading(true));
            let reqObj: any;
            const formData = new FormData();
            formData.append("file", values?.dumpFiles && values?.dumpFiles[0]);
            if (props.masterUidData) {
                formData.append("master_uid", props.masterUidData?.master_uid);
                formData.append("master_uid_field_id", props.masterUidData?.master_uid_field_id);
            }
            reqObj = formData;
            await dispatch(refreshTokenThunk());
            const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
            const ocrDumpAgent = aiAgents?.find((agent) => agent.name === agentNamesDataMap.ocr);
            const response: any = await uploadDumpFiles(props.projectData.TopicID, props.formData.id, ocrDumpAgent?.id, reqObj)
            dispatch(setLoading(false));
            showToaster(toasterTypes.SUCCESS, response.message);
            props.onClose();
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    }

    const renderAddDumpFiles = () => (
        <>
            <Row>
                <Col md={12}>
                    <FieldItem
                        name={"dumpFiles"}
                        placeholder={"Dump Files"}
                        label={"Dump Files"}
                        type={FIELD_TYPES.FILE_UPLOAD}
                        acceptFiles={"zip|pdf|png|jpeg|jpg"}
                        value={values.dumpFiles}
                        onChange={(...e) => handleChange("dumpFiles", ...e)}
                        touched={fields.dumpFiles && fields.dumpFiles.hasError}
                        error={fields.dumpFiles && fields.dumpFiles.errorMsg}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <p className="dumpfiles-note">NOTE : To dump multiple files, compress them into a ZIP file.</p>
                    <p className="dumpfiles-note">Allowed File Types : zip, image, pdf</p>
                    <p className="dumpfiles-note-warning">Please ensure the zip contains no more than 40 files.</p>
                </Col>
            </Row>
        </>
    );

    const getStatusColor = (status) => {
        const statusLower = status.toLowerCase();
        if (statusLower.includes('completed')) return '#28a745'; // green
        if (statusLower.includes('failed')) return '#dc3545'; // red
        if (statusLower.includes('inprogress') || statusLower.includes('in_progress')) return '#ffc107'; // yellow
        return '#6c757d'; // default gray
    };

    const getStatusIcon = (status) => {
        const statusLower = status.toLowerCase();
        if (statusLower.includes('completed')) return '✓';
        if (statusLower.includes('failed')) return '✗';
        if (statusLower.includes('inprogress') || statusLower.includes('in_progress')) return '⏳';
        return '•';
    };

    const renderViewStatus = () => {

        const statusData = dumpFilesStatus || [];


        return (
            <Row>
                <Col md={12}>
                    <div className="dump-status-container">
                        {statusData?.jobs && statusData?.jobs?.length > 0 ? (
                            statusData.jobs.map((job, jobIndex) => (
                                <div key={job.job_id} className="job-container">
                                    <div className="job-header">
                                        <h6 className="job-file-name">{job.uploaded_job_file}</h6>
                                        <small className="job-date">
                                            Uploaded: {new Date(job.created_at).toLocaleString()}
                                        </small>
                                    </div>

                                    <div className="tasks-container">
                                        {job.tasks && job.tasks.map((task, taskIndex) => (
                                            <div key={task.task_id} className="task-item">
                                                <div className="task-info">
                                                    {/* <span
                                                        className="status-icon"
                                                        style={{ color: getStatusColor(task.status) }}
                                                    >
                                                        {getStatusIcon(task.status)}
                                                    </span> */}
                                                    <span className="task-file">{task.task_file}</span>
                                                    <span
                                                        className="task-status"
                                                        style={{ color: getStatusColor(task.status) }}
                                                    >
                                                        {task.status}
                                                    </span>
                                                </div>
                                                {task.last_error && (
                                                    <div className="task-error">
                                                        Error: {task.last_error}
                                                    </div>
                                                )}
                                                <div className="task-updated">
                                                    Last updated: {new Date(task.updated_at).toLocaleString()}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-jobs">No upload jobs found.</p>
                        )}
                    </div>
                </Col>
            </Row>
        );
    };

    const getFooterButtons = () => {
        if (activeTab === '1') {
            return (
                <CustomButton
                    type="primary"
                    isDisabled={false}
                    text="Save"
                    onClick={() => onSave()}
                />
            );
        }
        return null; // No save button for view status tab
    };

    return (
        <>
            {
                // isCreditsAvailable === false ?
                //     (<NoUserCreditsModal />) :

                <ModalComponent
                    width={window.innerWidth > 700 ? "600px" : "350px"}
                    isOpen={true}
                    onClose={() => props.onClose()}
                    header={"Dump Files"}
                    centered={true}
                    customClass='dump-files-modal'
                    body={
                        <>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { toggle('1'); }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Add Dump Files
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => { toggle('2'); }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        View Status
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab} className="mt-3">
                                <TabPane tabId="1">
                                    {renderAddDumpFiles()}
                                </TabPane>
                                <TabPane tabId="2">
                                    {renderViewStatus()}
                                </TabPane>
                            </TabContent>
                        </>
                    }
                    footer={
                        <div>
                            {getFooterButtons()}
                        </div>
                    }
                />
            }
        </>
    )
}

export default Dump